import { Group, Pagination, Text } from '@mantine/core';
import { useEffect, useState } from 'react';

import { Select } from '../Select';
import classes from './Table.module.css';

const DEFAULT_PAGE_SIZE = 10;

interface TablePaginationProps {
  total: number;
  defaultPagination?: {
    page: number;
    perPage: number;
  };
  onPaginationChange: (page: number, pageSize: number) => void;
  disabled?: boolean;
  'data-pw'?: string;
}

export const TablePagination: React.FC<TablePaginationProps> = ({
  defaultPagination: { page: defaultPage, perPage: defaultSize },
  total,
  onPaginationChange,
  disabled,
  'data-pw': dataPw,
}) => {
  const [page, setPage] = useState(defaultPage ?? 1);
  const [pageSize, setPageSize] = useState(defaultSize ?? DEFAULT_PAGE_SIZE);
  const totalPages = Math.ceil(total / pageSize);

  const startRow = pageSize * (page - 1) + 1;
  const endRow = page * pageSize;

  const onPageSizeChange = (value: string | null) => {
    setPageSize(value ? +value : DEFAULT_PAGE_SIZE);
    onPaginationChange(1, value ? +value : DEFAULT_PAGE_SIZE);
  };

  const onPageChange = (value: number) => {
    setPage(value);
    onPaginationChange(value, pageSize);
  };

  useEffect(() => {
    if (defaultPage && defaultSize) {
      setPage(defaultPage);
      setPageSize(defaultSize);
    }
  }, [defaultPage, defaultSize]);

  return (
    <Group justify="flex-end" align="center" p="xl">
      {total > 0 && (
        <Select
          classNames={{ input: classes.selectInput }}
          w={80}
          size="sm"
          allowDeselect
          type="number"
          defaultValue={`${pageSize ?? '10'}`}
          data={['10', '20', '100']}
          onChange={onPageSizeChange}
        />
      )}
      {totalPages > 0 && (
        <Group justify="flex-end">
          <Text>
            {startRow} - {endRow < total ? endRow : total} of{' '}
            <Text span data-pw="pagination-total-rows-number">
              {total}
            </Text>
          </Text>
          <Pagination
            total={totalPages}
            onChange={onPageChange}
            value={page}
            withPages={false}
            disabled={disabled}
            getControlProps={(control) => ({
              'data-pw': `${dataPw}-pagination-${control}-button`,
            })}
          />
        </Group>
      )}
    </Group>
  );
};
